module.exports = __webpack_public_path__ + "static/media/ArrowRight.f07b8873.svg";